import React from 'react';
// Importação de ícones de `react-icons` para o coração
import { FaHeart } from 'react-icons/fa';

// Componente para os Detalhes do Programa (Frequência, Duração, etc.)
const ProgramDetailItem = ({ title, description }) => (
  <div className="mb-2">
    <span className="font-semibold">{title}:</span>{' '}
    <span className="text-sm">{description}</span>
  </div>
);

// Componente para os Passos do "Como funciona?"
const StepCard = ({ number, title, description }) => (
  <div className="bg-gray-100 p-6 rounded-xl shadow-md h-full flex flex-col items-start">
    {/* Bloco do Número/Título */}
    <div className="flex items-center mb-3">
      <div className={`w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center font-bold text-lg mr-3`}>
        {number}
      </div>
      <h3 className={`text-xl font-bold text-[#3A4785]`}>{title}</h3>
    </div>
    
    <p className="text-gray-700 leading-relaxed text-sm">
      {description}
    </p>
  </div>
);


// Componente Principal
function CuidadosPaliativos() {

  return (
    // Container Principal
    <div className="min-h-screen lg:pt-20 bg-gray-50">

      {/* Seção 1: Cabeçalho (Azul Escuro) */}
      <header className={`bg-primary pt-10 pb-20 px-4 md:px-8 text-white text-center`}>
        <div className="max-w-4xl mx-auto">
          
          {/* Ícone do Coração */}
          <div className="mb-6">
            <FaHeart className={`w-16 h-16 mx-auto text-third`} />
          </div>

          <h1 className="text-4xl md:text-5xl font-extrabold mb-2">
            Cuidados Paliativos
          </h1>
          <p className="text-lg md:text-xl px-4">
            Proporcionando conforto, dignidade e acompanhamento emocional a pacientes.
          </p>
        </div>
      </header>

      {/* Seção Principal de Conteúdo */}
      <main className="max-w-6xl mx-auto -mt-12 px-4 md:px-8">
        
        {/* Bloco de Informações - Sobre o Programa (Divisão em 2 colunas) */}
        <div className="grid md:grid-cols-2 gap-6 mb-12">

          {/* Coluna 1: Sobre o Programa - Texto Longo (Fundo Branco) */}
          <div className={`bg-white p-8 rounded-xl shadow-lg border-t-4 border-primary`}>
            <h2 className={`text-2xl font-bold text-primary mb-4`}>
              Sobre o Programa
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              O programa de Cuidados Paliativos da Associação Keralty oferece suporte emocional, social e recreativo a pacientes em tratamento paliativo e suas famílias.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Nossos voluntários são treinados para proporcionar conforto, ouvir com empatia e oferecer companhia significativa durante momentos delicados.
            </p>
          </div>

          {/* Coluna 2: Sobre o Programa - Detalhes (Fundo Verde Água) */}
          <div className={`bg-third p-8 rounded-xl shadow-lg text-white`}>
            <h2 className="text-2xl font-bold mb-4">
              Sobre o Programa
            </h2>
            <ProgramDetailItem
              title="Frequência"
              description="Flexível (conforme disponibilidade)"
            />
            <ProgramDetailItem
              title="Duração"
              description="2-4 horas por visita"
            />
            <ProgramDetailItem
              title="Treinamento"
              description="Oferecido pela Keralty"
            />
            <ProgramDetailItem
              title="Localização"
              description="Hospitais e unidades parceiras"
            />
          </div>

        </div>

        {/* Seção 2: Como funciona? (3 Cards de Passos) */}
        <section className="py-8">
          <h2 className={`text-3xl font-bold text-primary mb-8 text-center`}>
            Como funciona?
          </h2>
          <div className="grid md:grid-cols-3 gap-6">

            <StepCard
              number={1}
              title="Inscrição"
              description="Preencha o formulário de inscrição e indique sua disponibilidade."
            />

            <StepCard
              number={2}
              title="Treinamento"
              description="Receba treinamento sobre cuidados e acompanhamento emocional."
            />

            <StepCard
              number={3}
              title="Atuação"
              description="Comece a fazer diferença na vida de pacientes e famílias."
            />

          </div>
        </section>

      </main>
      
      {/* Seção 3: CTA (Call to Action) */}
      <div className="text-center py-10 bg-gray-50">
        <p className={`text-2xl font-semibold text-primary mb-6`}>
          Pronto para se voluntariar?
        </p>
        <button
          className={`bg-fourth hover:bg-opacity-80 text-white font-bold py-3 px-8 rounded-full text-lg shadow-xl transition duration-300 ease-in-out transform hover:scale-105`}
          onClick={() => alert('Direcionando para a página de inscrição...')}
        >
          Inscreva-se
        </button>
      </div>

    </div>
  );
};

export default CuidadosPaliativos;